import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image'
import React from 'react'

export type LogoProps = {
  image: string | IGatsbyImageData | null
  alt: string | null
  additionalClasses?: string
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
}

const Logo: React.FC<LogoProps> = ({
  image,
  alt,
  additionalClasses = undefined,
  objectFit = 'contain',
}) => {
  // vérification si image est bien de type IGatsbyImageData
  if (image && typeof image !== 'string' && 'images' in image) {
    const logo = getImage(image)
    const logoAlt = alt ? `logo de ${alt}` : "logo de l'entreprise"

    if (logo) {
      return (
        <GatsbyImage
          className={additionalClasses}
          objectFit={objectFit}
          image={logo}
          alt={logoAlt}
        />
      )
    }

    return (
      <img
        className={additionalClasses}
        src="Logo_V_Lamacompta.jpg"
        alt={logoAlt}
      />
    )
  }

  if (typeof image === 'string') {
    return (
      <img
        className={additionalClasses}
        src={image}
        alt={alt ?? "logo de l'entreprise"}
      />
    )
  }

  return (
    <img
      className={additionalClasses}
      src="../../../Logo_V_Lamacompta.jpg"
      alt="logo de l'entreprise"
    />
  )
}
export default Logo
